// src/components/buyerPersona/ModuleProgress.jsx
import React from 'react';
import { FaCheck, FaLock } from 'react-icons/fa';

const ModuleProgress = ({ modules, currentModule, responses, totalProgress, onModuleClick, questions }) => {
    const getModuleStatus = (moduleIndex) => {
        const moduleName = modules[moduleIndex];
        const moduleQuestions = questions.filter(q => q.module === moduleName);
        const answeredQuestions = moduleQuestions.filter(q => responses[q.question] !== undefined);

        if (answeredQuestions.length === moduleQuestions.length && moduleQuestions.length > 0) {
            return 'completed';
        }
        if (answeredQuestions.length > 0) {
            return 'in-progress';
        }
        if (moduleIndex > currentModule) {
            return 'locked';
        }
        return 'pending';
    };

    return (
        <div className="bg-white px-4 py-2 border-b border-gray-100">
            {/* Módulo actual y progreso */}
            <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-900">
                    Módulo {currentModule + 1} de {modules.length}
                </span>
                <span className="text-sm font-medium text-blue-600">
                    {Math.round(totalProgress)}%
                </span>
            </div>

            {/* Indicadores de módulo */}
            <div className="flex gap-1">
                {modules.map((module, index) => {
                    const status = getModuleStatus(index);
                    const isActive = index === currentModule;

                    return (
                        <button
                            key={module}
                            onClick={() => status !== 'locked' && onModuleClick(index)}
                            disabled={status === 'locked'}
                            className={`flex-1 h-1.5 rounded-full transition-all ${isActive
                                    ? 'bg-blue-500'
                                    : status === 'completed'
                                        ? 'bg-green-500'
                                        : status === 'in-progress'
                                            ? 'bg-yellow-500'
                                            : 'bg-gray-200'
                                }`}
                            title={`${module} - ${status === 'completed'
                                    ? 'Completado'
                                    : status === 'in-progress'
                                        ? 'En progreso'
                                        : status === 'locked'
                                            ? 'Bloqueado'
                                            : 'Pendiente'
                                }`}
                        />
                    );
                })}
            </div>

            {/* Nombre del módulo actual */}
            <div className="mt-1">
                <p className="text-xs text-gray-500 truncate">
                    {modules[currentModule]}
                </p>
            </div>
        </div>
    );
};

export default ModuleProgress; 